import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import { TBonusModalProps } from './types';
import { BonusModalContent } from './components';

export const BonusModal: React.FC<React.PropsWithChildren<TBonusModalProps>> = props => {
  if (props.open) {
    const { title, htmlContent, onClose } = props;

    return (
      <ModalWindow open onClose={onClose} maxWidth={928}>
        <BonusModalContent title={title} htmlContent={htmlContent} onClose={onClose} />
      </ModalWindow>
    );
  }

  return null;
};
